// Api
import * as Api from "./api";
import DateHelper from "common/utils/DateHelper";
//-- Constants -------------------------------------------------------------------------------------------------------------------------------
export const FETCHING = "AGENCY_REPORT_FETCHING_OVERVIEW";
export const LOAD = "AGENCY_REPORT_OVERVIEW";
export function fetchingData(agencyId, fromDate, toDate) {
    return {
        type: FETCHING,
        agencyId: agencyId,
        fromDate: fromDate,
        toDate: toDate
    };
}
export default function recievedData(report) {
    return {
        type: LOAD,
        report: report
    };
}
//-- Get Data -------------------------------------------------------------------------------------------------------------------------------
// Get if needed
export const getIfNeeded = (agencyId, report) => {
    return (dispatch) => {
        if (report === null || report.agencyId != agencyId) {
            getAgencyOverview(dispatch, agencyId, null, null);
        }
    };
};
// Get forced
export const getForced = (agencyId, startDate, endDate) => {
    return (dispatch) => {
        getAgencyOverview(dispatch, agencyId, startDate, endDate);
    };
};
// Get Data
const getAgencyOverview = (dispatch, agencyId, fromDate, toDate) => {
    // Default date range for report
    if (!fromDate || !toDate) {
        let defaultRange = DateHelper.getLastMonth();
        fromDate = defaultRange[0];
        toDate = defaultRange[1];
    }
    // Dispatch that we are fetching the report
    dispatch(fetchingData(agencyId, fromDate, toDate));
    // Fetch
    Api.async_overviewRequest(dispatch, agencyId, fromDate, toDate)
        .then((report) => {
        dispatch(recievedData(report));
    }, (message) => {
        dispatch(recievedData({
            isFetching: false,
            agencyId: agencyId,
            agencyName: "",
            startDate: fromDate,
            endDate: toDate,
            items: [],
            totals: {
                totalListings: 0,
                totalSaleListings: 0,
                totalRentalListings: 0,
                totalViews: 0,
                totalSaleViews: 0,
                totalRentalViews: 0,
                totalOtherViews: 0,
                totalLeads: 0,
                totalSaleLeads: 0,
                totalRentalLeads: 0,
                totalOtherLeads: 0
            }
        }));
    });
};
//-------------------------------------------------------------------------------------------------------------------------------
